import { array, boolean, mixed, object, ObjectSchema, string } from "yup";
import { AcknowledgementPriceFormatType, AcknowledgmentEmailFormatType } from "types/declarations/enums.ts";
import { EmailFieldRequiredErrorText, EmailFieldUniqueErrorText } from "components/Preferences/text.ts";

export interface FormSchema {
	email?: string;
	isAckReceive?: boolean;
	ackEmailFormat: AcknowledgmentEmailFormatType;
	ackPriceFormat: AcknowledgementPriceFormatType;
}

export interface AckEmailFormValues {
	cards: FormSchema[];
}
export const ackEmailAddressSchemaObject = {
	email: string().required(EmailFieldRequiredErrorText).email(EmailFieldUniqueErrorText),
	isAckReceive: boolean().required(),
	ackEmailFormat: mixed<AcknowledgmentEmailFormatType>().required(),
	ackPriceFormat: mixed<AcknowledgementPriceFormatType>().required()
} as const;

export const schema: ObjectSchema<FormSchema> = object(ackEmailAddressSchemaObject);

export const formSchema: ObjectSchema<AckEmailFormValues> = object({ cards: array().of(schema).required() });
